"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createOrderV1 = exports.createOrder = exports.PreactivationStatuses = void 0;
const config_1 = require("../config");
const ecommApi_1 = require("./ecommApi");
/** @deprecated Use `PreActivationEligibility` instead */
exports.PreactivationStatuses = {
    ELIGIBLE: 'eligible',
    INELIGIBLE: 'ineligible',
    PENDING: 'pending'
};
/**
 * Create a new order based on the cart ID in the request.
 *
 * @param request The parameters to generate a new order from.
 * @deprecated Use `createOrderV1` instead
 */
const createOrder = (request) => {
    const options = buildFetchOptions(request);
    const url = `${config_1.ordersApiUrl}/v1/orders`;
    return (0, ecommApi_1.attemptApiRequest)(url, options);
};
exports.createOrder = createOrder;
/**
 * Create a new order based on the cart ID in the request.
 *
 * @param request The parameters to generate a new order from.
 */
const createOrderV1 = (request) => {
    const options = buildFetchOptions(request);
    const url = `${config_1.ordersApiUrl}/v1/orders`;
    return (0, ecommApi_1.attemptApiRequest)(url, options);
};
exports.createOrderV1 = createOrderV1;
const buildFetchOptions = (body) => ({
    body: JSON.stringify(body),
    method: 'POST'
});
//# sourceMappingURL=ordersClient.js.map